import type { Observable } from 'rxjs';
import type { CityOption } from '../models/commerce-landing.model';

export abstract class CityPort {
  abstract loadByCountry(codPais: string): Observable<CityOption[]>;
}
